<div class="container-fluid">
  <div class="row">
    <div class="col-12 mb-2">
      <nav
        class="d-flex align-items-center flex-wrap gap-2"
        aria-label="breadcrumb"
      >
        <a
          class="back-link d-flex align-items-center justify-content-center rounded-circle text-decoration-none"
          [routerLink]="['/applicationConfiguration', appId]"
          [title]="'COMMON.BACK' | translate"
        >
          <mat-icon class="text-primary">arrow_back</mat-icon>
        </a>

        <div class="d-flex align-items-center">
          <mat-icon class="me-3" color="primary">payment</mat-icon>
          <p class="fw-semibold mb-0" style="font-size: 20px">
            {{ "PaymentS.Payment_configuration" | translate }}
          </p>
        </div>

        <span class="text-secondary mx-2">/</span>
        <span class="text-secondary">{{
          "PaymentS.Gateway_Settings_Title" | translate
        }}</span>
      </nav>
    </div>
    <div class="col-12">
      <div class="card">
        <div class="card-header d-flex p-3">
          <h5 class="card-title mb-0">
            {{ "PaymentS.Payment_Gateway_Configuration" | translate }}
          </h5>
        </div>

        <!-- Card Body -->
        <div class="card-body">
          <!-- Alerts -->
          <p *ngIf="form['error'] == false && form['message']">
            <app-ncs-alert
              [message]="form['message']"
              type="success"
              showAlert="true"
            ></app-ncs-alert>
          </p>
          <p *ngIf="form['error'] == true && form['message']">
            <app-ncs-alert
              [message]="form['message']"
              type="danger"
              showAlert="true"
            ></app-ncs-alert>
          </p>

          <!-- Payment Gateway Table -->
          <div class="col-md-12">
            <div class="table-container">
              <div class="table-responsive table-scrollable">
                <table
                  class="table table-bordered table-hover table-sticky-header"
                >
                  <thead>
                    <tr>
                      <th>{{ "PaymentS.Table.SNo" | translate }}</th>
                      <th>{{ "PaymentS.Table.Gateway_Name" | translate }}</th>
                      <th>{{ "PaymentS.Table.Active" | translate }}</th>
                      <th>{{ "PaymentS.Table.Created_Date" | translate }}</th>
                      <th>{{ "PaymentS.Table.Action" | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let g of gateways; let i = index">
                      <td>{{ i + 1 }}</td>
                      <td>{{ g.gatewayName }}</td>
                      <td>{{ g.isActive ? "Yes" : "No" }}</td>
                      <td>{{ g.createdDatetime | date: "short" }}</td>
                      <td>
                        <div class="d-flex gap-2">
                          <button
                            mat-stroked-button
                            color="primary"
                            type="button"
                            class="icon-width icon-center"
                            data-bs-toggle="modal"
                            data-bs-target="#testPaymentModal"
                            (click)="getPaymentGatewaysInfo(g.id)"
                            matTooltipPosition="above"
                          >
                            <mat-icon class="icon-compact"
                              >play_circle</mat-icon
                            >
                            <span class="ms-2">Test</span>
                          </button>

                          <button
                            mat-stroked-button
                            color="primary"
                            class="icon-width icon-center"
                            (click)="getPaymentGatewaysInfo(g.id); onEdit(g.id)"
                            [matTooltip]="'COMMON.EDIT' | translate"
                            matTooltipPosition="above"
                          >
                            <mat-icon class="icon-compact">edit</mat-icon>
                          </button>

                          <button
                            mat-stroked-button
                            color="warn"
                            class="icon-width icon-center"
                            (click)="deleteJasper(g.id)"
                            [matTooltip]="'COMMON.DELETE' | translate"
                            matTooltipPosition="above"
                          >
                            <mat-icon class="icon-compact">delete</mat-icon>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Upload Jasper Report -->
<div
  #testPaymentModal
  class="modal fade"
  id="testPaymentModal"
  tabindex="-1"
  aria-labelledby="uploadModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="testPaymentModal">Test Payment</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row g-4">
          <div class="col-12">
            <label for="amount" class="form-label mb-2">Amount</label>
            <mat-form-field appearance="outline" class="w-100">
              <input
                matInput
                type="number"
                id="amount"
                [(ngModel)]="testPaymentData.amount"
                [placeholder]="'Jasper.name.placeholder' | translate"
              />
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          mat-stroked-button
          color="primary"
          (click)="confirmTestPayment()"
          class="me-2"
        >
          <mat-icon>payments</mat-icon>
          Pay
        </button>

        <button
          type="button"
          mat-stroked-button
          color="warn"
          data-bs-dismiss="modal"
          [title]="'COMMON.CLOSE' | translate"
        >
          <mat-icon>close</mat-icon>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>